import {DATASET_MIXPANEL} from 'common/report/constants';

import {queryApiUrl} from '../utils';
import {BaseClient} from '../utils/base-client';
import {EVENT_SORT_TYPE, processEventNames} from './utils';

class TopEventsClient extends BaseClient {
  buildEndpoint() {
    return queryApiUrl(`events/names/`);
  }

  buildQueryParams({
    projectId,
    sortType = EVENT_SORT_TYPE.ALPHA,
    datasetId = DATASET_MIXPANEL,
    dataGroupId = null,
    queryOrigin = null,
    workspaceId = null,
    useQueryCache = null,
  } = {}) {
    /* eslint-disable camelcase */
    return {
      project_id: projectId,
      type: `general`,
      limit: 1500,
      ...(sortType === EVENT_SORT_TYPE.USAGE ? {sort_fn: `desc`} : {}),
      ...(datasetId !== DATASET_MIXPANEL ? {dataset_name: datasetId} : {}),
      ...(dataGroupId ? {data_group_id: dataGroupId} : {}),
      ...(queryOrigin ? {query_origin: queryOrigin} : {}),
      ...(workspaceId ? {workspace_id: workspaceId} : {}),
      ...(useQueryCache !== null ? {use_query_cache: useQueryCache} : {}),
    };
    /* eslint-enable camelcase */
  }

  processResponse(response, params) {
    return processEventNames(response, params);
  }
}

export const topEventsClient = new TopEventsClient();
